// SuccessGaugeChart.js
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PatientsSuccessChart = ({ t, percentage}: any) => {
    const data = {
        datasets: [
            {
                data: [percentage, 100 - percentage],
                backgroundColor: ['#6383F4', '#E0E3EE'],
                borderWidth: 10,
                cutout: '80%',
                circumference: 180,
                rotation: 270,
                borderRadius: 100,
            },
        ],
    };

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        hover: {
            mode: null,
        },
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false },
        },
    };

    return (
        <>
            <Doughnut data={data} options={options} />
            <div
                style={{
                    position: 'absolute',
                    top: '60%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    textAlign: 'center',

                }}
            >
                <p className='m-0 text-5xl font-bold' style={{ color: "#2D3967" }}>{percentage}%</p>
                <p className='m-0' style={{  color: '#727A99' }}>{t("patientSuccess")}</p>
            </div>
        </>
    );
};

export default PatientsSuccessChart;
